<template>
<div @click="emit" class="column">
  <slot/>
</div>  
</template>
<script>
export default {
  methods: {
    emit() {
      this.$emit('click')
    }
  }
}
</script>